import { ThemeUICSSObject } from '@apia/theme';

const configurationMenu: ThemeUICSSObject = {
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
};

export default configurationMenu;
